import { Theme } from "@emotion/react";

export const opportunitySavedCardContainer = (theme: Theme) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",

  width: "100%",
  padding: 24,

  cursor: "pointer",

  borderRadius: 8,
  border: `1px solid ${theme.colors.sysBorderDecorative}`,

  // Exclude dropdown menu content from triggering hover styles
  "&:hover:not(:has([data-radix-popper-content-wrapper]:hover))": {
    border: `1px solid ${theme.colors.sysPrimaryDefault}`,
    background: theme.colors.sysPrimarySubtle,
  },

  transition: "all 0.2s ease-in-out",
});

export const opportunitySavedCardIcon = (theme: Theme) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  width: 24,
  height: 24,

  background: theme.colors.sysBackgroundAlternative,
  borderRadius: 4,
});
